<template>
    <bridge-add-form></bridge-add-form>
</template>


<script>

    import BridgeAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            BridgeAddForm,
        },

    }
</script>

